// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__pcxzs","filesListContainer":"PosDisputesFiles_filesListContainer__w1H5s","filesButton":"PosDisputesFiles_filesButton__6i25T"};